/**
 * @param weightSeries
 * @param periodLength
 * @returns a new reference array
 */
export function fitWeightCurveToPeriod(weightSeries: number[], periodLength: number): number[] {
  if (weightSeries.length > periodLength) {
    return weightSeries.slice(weightSeries.length - periodLength, weightSeries.length);
  } else if (weightSeries.length < periodLength) {
    const lastWeight = weightSeries.length > 0 ? weightSeries[weightSeries.length - 1] : 0;
    return [...weightSeries, ...new Array(periodLength - weightSeries.length).fill(lastWeight)];
  }
  return weightSeries.slice();
}
